import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col overflow-auto bg-white [&::-webkit-scrollbar]:hidden" }
const _hoisted_2 = {
  key: 0,
  class: "flex h-[3.25rem] items-center px-4 text-lg font-semibold text-grey-900"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex min-w-px grow text-sm font-medium" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = {
  key: 0,
  class: "flex before:whitespace-pre before:content-['\\0020']"
}

import { computed } from 'vue'

interface Option {
  optGroupLabel?: string
  optLabel?: string
  optValue?: string | number
  optIcon?: string
  optHref?: string
  optCounter?: number
  iconPosition?: 'left' | 'right'
  copyable?: boolean
  disabled?: boolean
  options?: Option[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordList',
  props: {
    title: {},
    value: { default: null },
    options: {},
    unpadGrouped: { type: Boolean, default: false },
    showCounters: { type: Boolean, default: false },
    itemAlign: {}
  },
  emits: ["click", "link-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const optionsObject = computed(() => {
  const hasGroupedOptions = props.options.some(
    (opt) => opt.optGroupLabel && opt.options,
  )
  let optionsToUse = props.options

  if (hasGroupedOptions) {
    optionsToUse = props.options.flatMap((currentGroup) => [
      { optGroupLabel: currentGroup.optGroupLabel },
      ...(currentGroup.options ?? []),
    ])
  }

  return { grouped: hasGroupedOptions, options: optionsToUse }
})

const optionsHaveIcon = computed(() => optionsObject.value.options.some((op) => op.optIcon))

const listItemClass = [
  'flex h-12 cursor-pointer items-center',
  'justify-between gap-2 px-4 py-3',
  'text-sm font-medium leading-5 tracking-[0.0125rem]',
  'text-grey-900 hover:bg-primary-500 hover:text-white',
  'active:bg-primary-600 active:text-white',
  'sm:h-12 sm:p-4 sm:text-base',
]

function isSelected(option: Option) {
  return !!option.optValue && props.value === option.optValue
}

function selectOption(option: Option) {
  emit('click', option)
}

function handleLinkClick() {
  emit('link-click')
}

return (_ctx: any,_cache: any) => {
  const _component_sword_icon = _resolveComponent("sword-icon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(__props.title)), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsObject.value.options, (option, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!!option.optGroupLabel)
          ? (_openBlock(), _createElementBlock("span", {
              key: `label-${key}`,
              class: "flex h-12 items-end p-4 font-semibold text-grey-700 sm:h-12 sm:py-0 sm:text-xs"
            }, _toDisplayString(_ctx.$t(option.optGroupLabel)), 1))
          : (_openBlock(), _createElementBlock("li", {
              key: `item-${key}`
            }, [
              (!!option.optHref)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: _normalizeClass([listItemClass, 'truncate', {
            'pointer-events-none cursor-default bg-grey-200 text-grey-500': option.disabled,
          }]),
                    href: option.optHref,
                    target: "_blank",
                    onClick: _withModifiers(handleLinkClick, ["stop"])
                  }, [
                    _createVNode(_component_sword_icon, {
                      class: "mx-1 size-5 flex-none",
                      name: option.optIcon
                    }, null, 8, ["name"]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(option.optLabel ?? '')), 1),
                    _createVNode(_component_sword_icon, {
                      class: "ml-1 size-5 flex-none fill-grey-700",
                      name: "external-link"
                    })
                  ], 10, _hoisted_3))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([listItemClass, {
            'pointer-events-none bg-primary-100 font-medium text-grey-900': isSelected(option),
            'pointer-events-none cursor-default bg-grey-200 text-grey-500': option.disabled,
            'justify-center gap-1': __props.itemAlign === 'center',
            'justify-start gap-1': __props.itemAlign === 'start',
            'justify-end gap-1': __props.itemAlign === 'end',
          }]),
                    onClick: _withModifiers(($event: any) => (selectOption(option)), ["prevent"])
                  }, [
                    (optionsHaveIcon.value && (!option.iconPosition || option.iconPosition === 'right'))
                      ? (_openBlock(), _createBlock(_component_sword_icon, {
                          key: 0,
                          class: "size-5 flex-none",
                          name: option.optIcon
                        }, null, 8, ["name"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["flex min-w-px grow text-sm font-medium", { 'grow-0': __props.itemAlign }])
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(option.optLabel ?? '')), 1),
                      (__props.showCounters && option.optCounter != undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(option.optCounter) + ") ", 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    (option.copyable || (optionsHaveIcon.value && option.iconPosition === 'left'))
                      ? (_openBlock(), _createBlock(_component_sword_icon, {
                          key: 1,
                          class: "size-5 flex-none",
                          name: option.copyable ? 'copy' : option.optIcon
                        }, null, 8, ["name"]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_5))
            ]))
      ], 64))
    }), 256))
  ]))
}
}

})